import Vue from 'vue';
import actions from './nodes.actions';
import getters from './nodes.getters';

const state = {
  addNodesParams: {}
};

const mutations = {
  ADD_NODE_PARAMS(_state, payload) {
    Vue.set(_state, 'addNodesParams', payload);
  }
};

export default {
  name: 'nodes',
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
